import { AppEntities } from "../../../../config/entities";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";

const PriceTypeList = () => {
    const fields = [
        { title: "Name", fieldName: "name" },
        // { title: "TIN", fieldName: "tin" },
    ];

    return (
        <>
            <NewCatalogListView fields={fields} entity={AppEntities.PriceType} />
        </>
    );
}

export default PriceTypeList;